import { useSettings } from "@/context/SettingsContext";
import { EntityManager } from "./EntityManager";

const fields = [
  { name: "name", label: "Nom de la rubrique", required: true, full: true },
  { name: "order", label: "Ordre dans le menu", type: "number" },
];
const columns = [
  { key: "name", label: "Rubrique", render: (c) => <span className="font-semibold">{c.name}</span> },
  { key: "slug", label: "Adresse", render: (c) => <span className="text-xs text-zinc-500">/{c.slug === "chronique" ? "chronique" : `rubrique/${c.slug}`}</span> },
  { key: "order", label: "Ordre" },
];
const DEFAULTS = { name: "", order: 10 };

export default function CategoriesManager() {
  const { refreshCategories } = useSettings();
  return (
    <EntityManager title="Rubriques" description="Les rubriques apparaissent dans le menu, l'accueil et le pied de page. Une rubrique ne peut être supprimée que si aucun article ne l'utilise." listUrl="/categories" baseUrl="/categories" fields={fields} columns={columns} testId="categories" defaults={DEFAULTS} onChange={refreshCategories} />
  );
}
